const fr = {
  language: { label: 'Langue' },
  nav: {
    gift: 'Cadeau · 90 jours gratuits',
    pricing: 'Formules et tarifs',
    features: 'Fonctionnalités',
    ecosystem: 'Écosystème familial',
    clubs: 'Clubs',
    academy: 'Académie',
    lab: 'ROMIND LAB',
    safety: 'Sécurité',
    research: 'Recherche',
    insights: 'Articles',
    about: 'À propos',
    parentSafety: 'Sécurité pour les parents',
    joinTesting: 'Rejoindre les tests',
    contact: 'Contact',
    toggleMenu: 'Ouvrir le menu',
  },
  download: {
    nav: 'Télécharger l’appli',
    cta: 'Télécharger sur Google Play',
    available: 'Disponible maintenant',
    headline: 'ROMIND KIDS est disponible sur Google Play !',
    description: 'Amitié, créativité et apprentissage dans un univers conçu pour les 9–14 ans avec une attention particulière à la sécurité. Téléchargez l’application Android.',
    scan: 'Scannez le QR code pour ouvrir ROMIND KIDS sur Google Play.',
    qrAlt: 'QR code pour télécharger ROMIND KIDS sur Google Play',
  },
  footer: {
    tagline: 'Un univers créatif plus sûr pour les enfants de 9 à 14 ans — et la base de ROMIND Family Circle.',
    platform: 'Plateforme',
    legal: 'Mentions légales',
    home: 'Accueil',
    features: 'Fonctionnalités ROMIND KIDS',
    ecosystem: 'Écosystème familial',
    clubs: 'Clubs et défis',
    academy: 'ROMIND Academy',
    lab: 'ROMIND LAB',
    ventureStudio: 'Venture Studio',
    safety: 'Sécurité',
    safetyResearch: 'Recherche sur la sécurité',
    parentSafety: 'Sécurité pour les parents',
    insights: 'Articles',
    joinTesting: 'Rejoindre les tests',
    about: 'À propos',
    contact: 'Contact',
    privacy: 'Politique de confidentialité',
    terms: "Conditions d'utilisation",
    copyright: "Contenu utilisateur et droits d'auteur",
    community: 'Règles de la communauté',
    childSafetyModeration: 'Sécurité des enfants et modération',
    reportHandling: 'Traitement des signalements',
    dataRetention: 'Conservation et suppression des données',
    deleteAccount: 'Supprimer le compte',
    childSafetyOverview: 'Aperçu de la sécurité des enfants',
    childSafetyResearch: 'Recherche sur la sécurité des enfants',
    rights: '© 2025–2026 ROMIND KIDS — projet exploité par son fondateur. Tous droits réservés.',
    safetyPrinciples: 'Conçu selon des principes de sécurité des enfants',
  },
  legal: {
    eyebrow: 'Mentions légales',
    back: 'Retour à ROMIND KIDS',
    lastUpdated: 'Dernière mise à jour : {date}',
    operatorInfo: "Informations sur l'opérateur :",
    otherDocs: 'Autres documents juridiques et de sécurité',
  },
};

export default fr;